import React, { useContext, useState } from 'react';
import { Modal as ModalModule, UI, Grid, Utils } from 'common';

import AddEditGroupModal from './AddEditGroupModal.component';
import DeleteGroupModal from './DeleteGroupModal.component';

const { Modal, ModalContext } = ModalModule;
const { WrappedToolbar } = UI;
const { GridPanel } = Grid;
const { Logger } = Utils;

const ManageGroupsModal = ({ data: { groups, callBack }, modalId }) => {
	const { showModal } = useContext(ModalContext);
	const allGroups = groups.reduce((result, group) => {
		if (group.name !== 'Ungrouped') {
			result.push(group);
		}

		return result;
	}, []);
	const [rowData, setRowData] = useState(allGroups);
	const [selectedGroup, setSelectedGroup] = useState([]);

	const onSelectionChanged = selection => {
		setSelectedGroup(selection[0].data);
	};

	const onUpdateCallback = (action, group) => {
		const newGroup = group;
		const newRowData =
			action === 'Add'
				? rowData.concat(newGroup)
				: rowData.map(_group => {
						if (_group.id === group.id) {
							return newGroup;
						} else {
							return _group;
						}
				  });

		setRowData(newRowData);
		callBack(newRowData);
	};

	const onDeleteCallback = groupId => {
		const newRowData = rowData.filter(group => group.id !== groupId);
		setRowData(newRowData);
		setSelectedGroup([]);
		callBack(newRowData);
	};

	const launchAddModal = () => {
		showModal({
			component: AddEditGroupModal,
			data: {
				groups: rowData,
				action: 'Add',
				manageGroupsUpdateCallback: onUpdateCallback,
			},
		});

		Logger.logToServer({
			category: 'manage_groups_add',
			action: 'click',
			action_location: 'manage_groups_modal',
		});
	};

	const launchEditModal = () => {
		showModal({
			component: AddEditGroupModal,
			data: {
				groups: rowData,
				action: 'Edit',
				selectedGroup,
				manageGroupsUpdateCallback: onUpdateCallback,
			},
		});

		Logger.logToServer({
			category: 'manage_groups_edit',
			action: 'click',
			action_location: 'manage_groups_modal',
		});
	};

	const launchDeleteModal = () => {
		showModal({
			component: DeleteGroupModal,
			data: {
				selectedGroup,
				manageGroupsDeleteCallback: onDeleteCallback,
			},
		});

		Logger.logToServer({
			category: 'manage_groups_delete',
			action: 'click',
			action_location: 'manage_groups_modal',
		});
	};

	const buttons = [
		{
			label: 'Add',
			icon: 'add-icon',
			onClick: launchAddModal,
			tooltip: `${'Add'.bold()}\nAdd a new group`,
			tooltipOptions: {
				position: 'bottom',
			},
		},
		{
			label: 'Edit',
			disabled: selectedGroup.length === 0,
			onClick: launchEditModal,
			tooltip: `${'Edit'.bold()}\nEdit selected group`,
			tooltipOptions: {
				position: 'bottom',
			},
		},
		{
			label: 'Delete',
			disabled: selectedGroup.length === 0,
			onClick: launchDeleteModal,
			tooltip: `${'Delete'.bold()}\nDelete selected group`,
			tooltipOptions: {
				position: 'bottom',
			},
		},
	];

	return (
		<Modal
			modalId={modalId}
			className="contacts contacts-manage-groups-modal"
			header="Manage Groups"
			size="small"
			hideFooter
		>
			<WrappedToolbar buttons={buttons} dataqa="manage-groups-toolbar" />
			<GridPanel
				rowData={rowData}
				columnDefs={[
					{
						field: 'name',
						flex: 1,
					},
				]}
				showPagination={false}
				onSelectionChanged={onSelectionChanged}
				dataqa="manage-groups-grid"
			/>
		</Modal>
	);
};

export default ManageGroupsModal;
